import React from 'react';
import { Table } from 'reactstrap';

export default function ErrorTable({ errorData = [], dataConfig }) {
  const inferredConfig = React.useMemo(() => {
    if (dataConfig && dataConfig.length) return dataConfig;
    if (errorData.length === 0) return [];

    // Auto-generate config from the first row
    const keys = Object.keys(errorData[0]);
    return keys.map(key => ({
      key,
      label: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize first letter
    }));
  }, [dataConfig, errorData]);

  const renderHeaders = () =>
    inferredConfig.map(item => {
      if (item?.renderHeader) {
        return (
          <th key={item.key}>
            <div className="d-flex justify-content-between">
              <div>{item.label}</div>
              {item.renderHeader(item)}
            </div>
          </th>
        );
      }
      return <th key={item.key}>{item.label}</th>;
    });

  const renderBody = () => {
    if (errorData.length === 0) {
      return (
        <tr>
          <td colSpan={inferredConfig.length} className="text-center">
            No data available
          </td>
        </tr>
      );
    }
    return errorData.map(item => {
      const row = inferredConfig.map(config => {
        if (config?.render) {
          return <td key={config.key}>{config.render(item)}</td>;
        }
        return <td key={config.key}>{item[config.key]}</td>;
      });
      return <tr>{row}</tr>;
    });
  };

  return errorData.length === 0 ? (
    <div className="text-center py-2">No data available</div>
  ) : (
    <div
      className="table-responsive"
      style={{
        border: '2px solid #D0D5DD',
        borderRadius: '8px',
      }}
    >
      <Table className="custom-table mb-0">
        <thead>
          <tr>{renderHeaders()}</tr>
        </thead>
        <tbody>{renderBody()}</tbody>
      </Table>
    </div>
  );
}
